import { v4 as uuidv4 } from 'uuid';

export function ModalLayout(props, childrenComponents = []) {
	return {
		componentName: 'ModalLayout',
		componentId: uuidv4(),
		props: Object.assign(
			{
				scroll: 'content',
				disableEscapeKeyDown: false,
				fullScreen: false,
				backdrop: 'clickable',
				customPixelEventId: '',
				customPixelEventName: '',
			},
			props,
		),
		childrenComponents,
	};
}
